import { combineReducers } from "@reduxjs/toolkit";


import authReducer from '../redux/features/auth/authSlice';
import bannerReducer from '../redux/features/banner/bannerSlice';
import makeReducer from '../redux/features/make/makeSlice';
import modelReducer from '../redux/features/model/modelSlice';
import modelCodeReducer from '../redux/features/modelCode/modelCodeSlice';
import transmissionReducer from '../redux/features/transmission/transmissionSlice';
import fuelReducer from '../redux/features/fuel/fuelSlice';
import vehicleTypeReducer from '../redux/features/vehicleType/vehicleTypeSlice';
import countryReducer from '../redux/features/country/countrySlice';
import colorReducer from '../redux/features/color/colorSlice';
import vehicleReducer from '../redux/features/vehicle/vehicleSlice';
import contactUsReducer from '../redux/features/contactUs/contactUsSlice';

const appReducer = combineReducers({
    auth: authReducer,
    banner: bannerReducer,
    make: makeReducer,
    model: modelReducer,
    modelCode: modelCodeReducer,
    transmission: transmissionReducer,
    fuel: fuelReducer,
    vehicleType: vehicleTypeReducer,
    country: countryReducer,
    color: colorReducer,
    vehicle: vehicleReducer,
    contactUs: contactUsReducer,
});

const rootReducer = (state, action) => {
  if (
    action.type === "auth/signOut/fulfilled" ||
    action.type === "auth/signOut/rejected"
  ) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
